import React from 'react';
import { HomeLayout } from 'modules/home/components/HomeLayout';
import { onboardingElementIds } from 'services/onboarding/constants';
import { ChannelsAvailability } from 'modules/channels/components';

export const HomeChannelsTab: React.FC = () => {
  return (
    <HomeLayout>
      <div id={onboardingElementIds.homePageContainer}>
        <ChannelsAvailability />
      </div>
    </HomeLayout>
  );
};
